import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import ImageWithSkeleton from '../ImageWithSkeleton/ImageWithSkeleton';

const bem = new BEMHelper('DoubleImage');

const DoubleImage = (props) => {
    const {
        className,
        doubleImageModifier,
        doubleImageWithoutPadding,
        hideSecondaryOnMobile,
        ImageComponent = ImageWithSkeleton,
        imageOverlayElement,
        primaryPlpSrcset,
        primarySrcset,
        secondaryPlpSrcset,
        secondarySrc,
        secondarySrcset,
    } = props;

    if (!secondarySrc) return <ImageComponent {...props} noscript imageSrcset={primarySrcset} plpSrcset={primaryPlpSrcset} />;

    return (
        <div className={bem(null, null, className)}>
            <div className={bem(null, null, ['primaryImage', doubleImageWithoutPadding, doubleImageModifier])}>
                <ImageComponent {...props} noscript imageSrcset={primarySrcset} plpSrcset={primaryPlpSrcset} />
            </div>
            <div className={bem(null, null, ['secondaryImage', doubleImageWithoutPadding, doubleImageModifier])}>
                <ImageComponent
                    {...props}
                    noscript
                    hideOnMobile={hideSecondaryOnMobile}
                    imageSrcset={secondarySrcset}
                    plpSrcset={secondaryPlpSrcset}
                    src={secondarySrc}
                />
            </div>
            {imageOverlayElement}
        </div>
    );
};

DoubleImage.propTypes = {
    loading: PropTypes.bool,
    secondarySrc: PropTypes.string,
    secondaryMediaQuery: PropTypes.string,
    aspectRatio: PropTypes.string,
    src: PropTypes.string,
    intersected: PropTypes.bool,
    className: PropTypes.string,
    primarySrcset: PropTypes.string,
    secondarySrcset: PropTypes.string,
    hideSecondaryOnMobile: PropTypes.bool,
    imageSrcsetSize: PropTypes.string,
    ImageComponent: PropTypes.elementType,
    doubleImageWithoutPadding: PropTypes.string,
    doubleImageModifier: PropTypes.string,
    imageOverlayElement: PropTypes.node,
};

export default DoubleImage;
